module.exports = __webpack_public_path__ + "static/media/logo-main-fused.ea2f2129.png";